import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Chart as ChartJS, registerables } from "chart.js";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import sectionService from "../../services/section-service";
import userService from "../../services/user-service";
import dashboardService from "../../services/dashboard-service";
import { registerLocale } from "react-datepicker";
import { es } from "date-fns/locale/es";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Divider, Spin } from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import BarchartDay from "../DashBoard/BarchartDay";
import moment, { duration } from "moment/moment";
import { ToastContainer, toast } from 'react-toastify';
import Select from "react-select";
import MultiLineCycles from "../DashBoard/MultiLineCycles";


// Registrar componentes para Chart.js
ChartJS.register(...registerables);

const DashBoardCycles = () => {


  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();


  const chartOneRef = useRef(null);
  const chartTwoRef = useRef(null);
  const chartThreeRef = useRef(null);
  const chartFourRef = useRef(null);



  const [listCyclesPalm, setListCyclesPalm] = useState([])

  const [key, setKey] = useState(Date.now());
  const [showLineValues, setShowLineValues] = useState(true)
  const [expandChats, setExpandCharts] = useState(false)
  const [loading, setLoading] = useState(false);

  ///Aplicaciones por dia
  const [lotId, setLotId] = useState("0");
  const [sectionId, setSectionId] = useState("0");
  const [farmId, setFarmId] = useState("0");
  const [palmName, setPalmName] = useState("0");
  const [lineName, setLineName] = useState("0");


  ////CONSTANTES DE COORRELACION////////////////////////
  const [title, setTitle] = useState("Ciclos de polinización por sección")
  const [subTitle, setSubTitle] = useState("Ciclos de polinización por sección agrupado por mes")




  const [dataCycles, setDataCycles] = useState([])
  const [listFirstHectareLot, setListFirstHectareLot] = useState([])


  registerLocale("es", es);

  const start_date = moment().subtract(6, 'month').startOf('month').toDate();
  const end_date = moment().subtract(1, 'month').endOf('month').toDate();
  //const end_date = moment().endOf("day").toDate();


  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);


  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listSection, setListSection] = useState(escoja);
  const [listUsers, setListUsers] = useState(escoja);


  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  const [options, setOptions] = useState([])
  const [selectedLotes, setSelectedLotes] = useState([]);
  const handleSelectChange = (selectedOptions) => {
    setSelectedLotes(selectedOptions || []);
  };

  // Estilos personalizados  
  const customStyles = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#CBEDFE",
      fontFamily: "inherit",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
    menu: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
  };
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////






  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
      //setValue("farm",0)
    }
  };

  const getListSection = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setFarmId(code);
    if (code == "0") {
      setListSection(escoja);
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
    }
  };

  const getLisLots = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setSectionId(code);
    if (code == "0") {
      setListLots(escoja);
      return;
    }


    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      const newOptions = sortedItems.map((lote) => ({
        value: lote._id,
        label: lote.name,
      }));
      setOptions(newOptions)
    }
  };




  const formatDate = (dateString) => {
    return moment(dateString).locale('es').format('DD MMM');
  };



  /// OBTENER DATOS DE CICLOS POR FINCA
  const getDataCycles = async (start_date, end_date) => {
    setLoading(true);
    let start = moment(start_date).startOf("day").format('YYYY-MM-DD');
    let end = moment(end_date).endOf("day").format('YYYY-MM-DD');    
    const userId = getValues("userId")
    const result = await dashboardService.cyclesByFarmMonth(start, end, farmId, lotId, sectionId, selectedLotes,userId);
    if (result) {
      if (result.length == 0) {
        toast.info("No hay datos para mostrar", { autoClose: 1500 })
        return
      }
      setDataCycles(result)
    }
    setLoading(false);
  };




  /// OBTENER DATOS DE CICLOS POR SECCION
  const getDataCyclesSection = async (start_date, end_date) => {
    setLoading(true);
    let start = moment(start_date).startOf("day").format('YYYY-MM-DD');
    let end = moment(end_date).endOf("day").format('YYYY-MM-DD');   
    const userId = getValues("userId")
    const result = await dashboardService.cyclesBySectionMonth(start, end, farmId, lotId, sectionId, selectedLotes,userId);
    if (result) {
      if (result.length == 0) {
        toast.info("No hay datos para mostrar", { autoClose: 1500 })
      }
      setDataCycles(result)
    }
    setLoading(false);
  };




  /// OBTENER DATOS DE CICLOS POR LOTE
  const getDataCyclesLot = async (start_date, end_date) => {
    setLoading(true);
    let start = moment(start_date).startOf("day").format('YYYY-MM-DD');
    let end = moment(end_date).endOf("day").format('YYYY-MM-DD');   
    const userId = getValues("userId")
    const result = await dashboardService.cyclesByLotMonth(start, end, farmId, lotId, sectionId, selectedLotes,userId);
    if (result) {
      if (result.length == 0) {
        toast.info("No hay datos para mostrar", { autoClose: 1500 })
      }
      setDataCycles(result)
    }
    setLoading(false);
  };





  /// OBTENER DATOS DE CICLOS POR PALMA
  const getDataCyclesPalm = async (start_date, end_date) => {
    

    setLoading(true);
    let start = moment(start_date).startOf("day").format('YYYY-MM-DD');
    let end = moment(end_date).endOf("day").format('YYYY-MM-DD');   
    const userId = getValues("userId")

    const limit = 9;
    const params = {startDate:start,endDate:end,farmId,lotId,sectionId,lots:selectedLotes,userId,limit };
    const response = await dashboardService.cyclesByPalm(params);
    const rows = response.data
    setPalmName(response.palmName)
    setLineName(response.lineName)
    
    
    let listado = []
    setListCyclesPalm(listado)
    if (rows) {
      setListCyclesPalm(rows)

      let contador = 0;
      rows.map((item) => {
        contador++
        listado.push(
          {
            startDate: item.startDate,
            endDate: item.endDate,
            duration: item.duration
          });
        console.log(item)

      })


    }
    setLoading(false);
  };











  const loadDashBoard = () => {

    setListCyclesPalm([])

    
    setPalmName("0")
    setLineName("0")

    if (farmId == "0") {
      setTitle("Ciclos de polinización por fincas")
      setSubTitle("Ciclos de polinización por sección agrupado por mes")
      getDataCycles(startDate, endDate)
    }
    else if (sectionId == "0") {
      setTitle("Ciclos de polinización por sección")
      setSubTitle("Ciclos de polinización por sección agrupado por mes")
      getDataCyclesSection(startDate, endDate)
    }
    else if (lotId != "0") {
      setTitle("Ciclos de polinización por lotes")
      setSubTitle("Ciclos de polinización por lote agrupado por mes")
      getDataCyclesLot(startDate, endDate)
      getDataCyclesPalm(startDate, endDate)

    }
    else {
      setTitle("Ciclos de polinización por sección")
      setSubTitle("Ciclos de polinización por sección agrupado por mes")
      getDataCyclesSection(startDate, endDate)
    }

    setKey(Date.now());


  };







  const cardStyle = {
    padding: "20px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    borderRadius: "10px",
    backgroundColor: "#fff",
    minHeight: "480px"
  };

  const saveAsImage = (chartRef, title) => {
    if (chartRef.current) {
      const echartsInstance = chartRef.current.getEchartsInstance();
      const imgData = echartsInstance.getDataURL({
        type: "jpeg", // Formato de la imagen ('png', 'jpeg')
        pixelRatio: 2, // Relación de píxeles (mayor = imagen de mayor calidad)
        backgroundColor: "#fff", // Fondo de la imagen
      });

      // Crear un enlace para descargar la imagen
      const link = document.createElement("a");
      link.href = imgData;
      link.download = title; // Nombre del archivo
      link.click();
    }
  };





    const getListFilterUsers = async () => {
  
      const farmId = getValues("farm")
      const lotId = getValues("lot")
      const userId = "0"
      setValue("userId", "0")
      try {
        let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
        let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
        const response = await userService.listInAccumulation(start, end, farmId, sectionId, lotId)
        const listado = response.data
        if (listado) {
          listado.push({ _id: 0, name: "-ESCOJA-" });
          const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
          setListUsers(sortedItems);
        }
      } catch (error) { }
    }

    useEffect(() => {
      getListFilterUsers();
    }, [startDate, endDate, farmId, sectionId]);
  



  useEffect(() => {
    getLisFarm();
    setValue("days", 165)
    setValue("weight", 40)
    //loadDashBoard();
  }, []);



  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <ToastContainer />
      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Ciclos de polinización</Divider>
      </div>
      <div className="row">
        <div className="col-12">
          <form
            className="form-react"
            defaultValue={{ weight: 40 }}

          >
            <div className="row mb-3">


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Finca</label>
                <select
                  className="form-control text-secondary"
                  {...register("farm")}
                  onChange={(e) => getListSection(e)}
                >
                  {listFarms.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Sección</label>
                <select
                  className="form-control text-secondary"
                  {...register("section")}
                  onChange={(e) => getLisLots(e)}
                >
                  {listSection.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>




              <div className="col-12 col-sm-2">
                <label className="text-secondary fw-bold">Desde</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control text-secondary"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>

              <div className=" col-12  col-sm-2">
                <label className="text-secondary fw-bold">Hasta</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control 
                text-secondary"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                />
              </div>




              <div className="col-12 col-sm-2">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <Spin spinning={loading}  >
                  <button
                    className="btn btn-primary w-100"
                    type="button"
                    onClick={() => loadDashBoard()}
                  >
                    <i className="bi bi-search fa-lg m-2" /> Buscar
                  </button>
                </Spin>
              </div>



              <div className="col-12 col-sm-6 d-none">
                <label className="text-secondary fw-bold">Lotes</label>
                <Select
                  isMulti
                  options={options}
                  value={selectedLotes}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  placeholder="Selecciona lotes..."
                />
              </div>


              <div className=" col-3">
                <label className="text-secondary fw-bold">Lote</label>
                <select
                  className="form-control text-secondary"
                  {...register("lot")}
                  onChange={(e) => {
                    const value = e.target.value;
                    setLotId(value);
                  }}
                >
                  {listLots.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>



              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Usuario</label>
                <select
                  className="form-control text-secondary"
                  {...register("userId")}
                  onChange={(e) => {
                    const value = e.target.value;
                  }}
                >
                  {listUsers.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>



            </div>





          </form>
        </div>







        <div className={expandChats ? "col-12 mt-2" : "col-12 col-sm-8 mt-2"}>
          <div style={cardStyle}>
            <MultiLineCycles
              chartRef={chartOneRef}
              title={title}
              nameLine="Hectáreas"
              nameBar="Aplicaciones"
              subTitle=""
              labelY="Ciclos"
              showSerieValue={showLineValues}
              decimals={0}
              data={dataCycles}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartOneRef, "ciclos-polinizacion.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>






        <div className={lineName=="0" ? "d-none" : "col-12 col-sm-4 mt-2"}>
          <div style={cardStyle} >

            <strong>Duración últimos {listCyclesPalm.length} ciclos del lote</strong><br></br>
            <strong>Palma de referencia:</strong> Línea: {lineName} Palma: {palmName}
            <table className="table table-responsive table-bordered ">
              <thead className="table-primary" >
                <tr>
                  <th>Inicio</th>
                  <th>Fin</th>
                  <th>Duracion</th>
                </tr>
              </thead>
              <tbody>
                {listCyclesPalm.map((item) => {
                  if (!item.startDate) return;
                  return (
                    <tr key={item.id} >
                      <td>{formatDate(item.startDate)}</td>
                      <td>{formatDate(item.endDate)}</td>
                      <td>{item.duration}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>








      </div>
    </div>
  );
};

export default DashBoardCycles;
